/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { PracticalExamAttemptDto } from '../models';
// @ts-ignore
import type { StartPracticalExamAttemptRequestDto } from '../models';
// @ts-ignore
import type { UpdatePracticalExamAttemptStatusRequestDto } from '../models';
/**
 * PracticalExamAttemptApi - axios parameter creator
 * @export
 */
export const PracticalExamAttemptApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a single practical exam attempt
         * @param {number} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamAttempt: async (attemptId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('getPracticalExamAttempt', 'attemptId', attemptId)
            const localVarPath = `/api/v2/practical-exam-attempts/{attemptId}`
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all practical exam attempts for a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPracticalExamAttempts: async (certificationId: number, stageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('listPracticalExamAttempts', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('listPracticalExamAttempts', 'stageId', stageId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/practical-exam-attempts`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a new practical exam attempt for an employee
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {StartPracticalExamAttemptRequestDto} startPracticalExamAttemptRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPracticalExamAttempt: async (certificationId: number, stageId: number, startPracticalExamAttemptRequestDto: StartPracticalExamAttemptRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('startPracticalExamAttempt', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('startPracticalExamAttempt', 'stageId', stageId)
            // verify required parameter 'startPracticalExamAttemptRequestDto' is not null or undefined
            assertParamExists('startPracticalExamAttempt', 'startPracticalExamAttemptRequestDto', startPracticalExamAttemptRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/practical-exam-attempts`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startPracticalExamAttemptRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update practical exam attempt status (complete or abandon)
         * @param {number} attemptId 
         * @param {UpdatePracticalExamAttemptStatusRequestDto} updatePracticalExamAttemptStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePracticalExamAttemptStatus: async (attemptId: number, updatePracticalExamAttemptStatusRequestDto: UpdatePracticalExamAttemptStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('updatePracticalExamAttemptStatus', 'attemptId', attemptId)
            // verify required parameter 'updatePracticalExamAttemptStatusRequestDto' is not null or undefined
            assertParamExists('updatePracticalExamAttemptStatus', 'updatePracticalExamAttemptStatusRequestDto', updatePracticalExamAttemptStatusRequestDto)
            const localVarPath = `/api/v2/practical-exam-attempts/{attemptId}`
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePracticalExamAttemptStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PracticalExamAttemptApi - functional programming interface
 * @export
 */
export const PracticalExamAttemptApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PracticalExamAttemptApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a single practical exam attempt
         * @param {number} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPracticalExamAttempt(attemptId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamAttemptDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPracticalExamAttempt(attemptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamAttemptApi.getPracticalExamAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all practical exam attempts for a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPracticalExamAttempts(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PracticalExamAttemptDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPracticalExamAttempts(certificationId, stageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamAttemptApi.listPracticalExamAttempts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a new practical exam attempt for an employee
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {StartPracticalExamAttemptRequestDto} startPracticalExamAttemptRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startPracticalExamAttempt(certificationId: number, stageId: number, startPracticalExamAttemptRequestDto: StartPracticalExamAttemptRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticalExamAttemptDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startPracticalExamAttempt(certificationId, stageId, startPracticalExamAttemptRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamAttemptApi.startPracticalExamAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update practical exam attempt status (complete or abandon)
         * @param {number} attemptId 
         * @param {UpdatePracticalExamAttemptStatusRequestDto} updatePracticalExamAttemptStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePracticalExamAttemptStatus(attemptId: number, updatePracticalExamAttemptStatusRequestDto: UpdatePracticalExamAttemptStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePracticalExamAttemptStatus(attemptId, updatePracticalExamAttemptStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PracticalExamAttemptApi.updatePracticalExamAttemptStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PracticalExamAttemptApi - factory interface
 * @export
 */
export const PracticalExamAttemptApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PracticalExamAttemptApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a single practical exam attempt
         * @param {number} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPracticalExamAttempt(attemptId: number, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamAttemptDto> {
            return localVarFp.getPracticalExamAttempt(attemptId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all practical exam attempts for a stage
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPracticalExamAttempts(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PracticalExamAttemptDto>> {
            return localVarFp.listPracticalExamAttempts(certificationId, stageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a new practical exam attempt for an employee
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {StartPracticalExamAttemptRequestDto} startPracticalExamAttemptRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startPracticalExamAttempt(certificationId: number, stageId: number, startPracticalExamAttemptRequestDto: StartPracticalExamAttemptRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamAttemptDto> {
            return localVarFp.startPracticalExamAttempt(certificationId, stageId, startPracticalExamAttemptRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update practical exam attempt status (complete or abandon)
         * @param {number} attemptId 
         * @param {UpdatePracticalExamAttemptStatusRequestDto} updatePracticalExamAttemptStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePracticalExamAttemptStatus(attemptId: number, updatePracticalExamAttemptStatusRequestDto: UpdatePracticalExamAttemptStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePracticalExamAttemptStatus(attemptId, updatePracticalExamAttemptStatusRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PracticalExamAttemptApi - interface
 * @export
 * @interface PracticalExamAttemptApi
 */
export interface PracticalExamAttemptApiInterface {
    /**
     * 
     * @summary Get a single practical exam attempt
     * @param {number} attemptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamAttemptApiInterface
     */
    getPracticalExamAttempt(attemptId: number, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamAttemptDto>;

    /**
     * 
     * @summary List all practical exam attempts for a stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamAttemptApiInterface
     */
    listPracticalExamAttempts(certificationId: number, stageId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PracticalExamAttemptDto>>;

    /**
     * 
     * @summary Start a new practical exam attempt for an employee
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {StartPracticalExamAttemptRequestDto} startPracticalExamAttemptRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamAttemptApiInterface
     */
    startPracticalExamAttempt(certificationId: number, stageId: number, startPracticalExamAttemptRequestDto: StartPracticalExamAttemptRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<PracticalExamAttemptDto>;

    /**
     * 
     * @summary Update practical exam attempt status (complete or abandon)
     * @param {number} attemptId 
     * @param {UpdatePracticalExamAttemptStatusRequestDto} updatePracticalExamAttemptStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamAttemptApiInterface
     */
    updatePracticalExamAttemptStatus(attemptId: number, updatePracticalExamAttemptStatusRequestDto: UpdatePracticalExamAttemptStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * PracticalExamAttemptApi - object-oriented interface
 * @export
 * @class PracticalExamAttemptApi
 * @extends {BaseAPI}
 */
export class PracticalExamAttemptApi extends BaseAPI implements PracticalExamAttemptApiInterface {
    /**
     * 
     * @summary Get a single practical exam attempt
     * @param {number} attemptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamAttemptApi
     */
    public getPracticalExamAttempt(attemptId: number, options?: RawAxiosRequestConfig) {
        return PracticalExamAttemptApiFp(this.configuration).getPracticalExamAttempt(attemptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all practical exam attempts for a stage
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamAttemptApi
     */
    public listPracticalExamAttempts(certificationId: number, stageId: number, options?: RawAxiosRequestConfig) {
        return PracticalExamAttemptApiFp(this.configuration).listPracticalExamAttempts(certificationId, stageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a new practical exam attempt for an employee
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {StartPracticalExamAttemptRequestDto} startPracticalExamAttemptRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamAttemptApi
     */
    public startPracticalExamAttempt(certificationId: number, stageId: number, startPracticalExamAttemptRequestDto: StartPracticalExamAttemptRequestDto, options?: RawAxiosRequestConfig) {
        return PracticalExamAttemptApiFp(this.configuration).startPracticalExamAttempt(certificationId, stageId, startPracticalExamAttemptRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update practical exam attempt status (complete or abandon)
     * @param {number} attemptId 
     * @param {UpdatePracticalExamAttemptStatusRequestDto} updatePracticalExamAttemptStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PracticalExamAttemptApi
     */
    public updatePracticalExamAttemptStatus(attemptId: number, updatePracticalExamAttemptStatusRequestDto: UpdatePracticalExamAttemptStatusRequestDto, options?: RawAxiosRequestConfig) {
        return PracticalExamAttemptApiFp(this.configuration).updatePracticalExamAttemptStatus(attemptId, updatePracticalExamAttemptStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

